import getCurrentApp from '../utils/getCurrentApp';
import getCurrentUrlWithoutPortalId from '../utils/getCurrentUrlWithoutPortalId';
import { getNotificationsUsageTracker } from '../utils/analytics/NotificationTracker';
import { _getLevelFromClass } from './utils/getLevelFromClass';
import getDataAttr from './utils/getDataAttr';
const useUsageTracker = () => {
  const track = (type, properties) => {
    const NotificationsUsageTracker = getNotificationsUsageTracker();
    if (!NotificationsUsageTracker) {
      return;
    }
    NotificationsUsageTracker.track(type, properties);
  };
  const trackNotificationsClick = event => {
    if (!event.currentTarget || !(event.currentTarget instanceof HTMLElement)) {
      return;
    }
    const currentUrl = getCurrentUrlWithoutPortalId();
    const destinationUrl = event.currentTarget.hasAttribute('href') ? event.currentTarget.getAttribute('href').replace(/[0-9]/g, '') : '';
    const currentApp = getCurrentApp();
    const payload = {
      currentUrl,
      destinationUrl,
      currentApp,
      screen: currentApp,
      isNewNav: true,
      level: _getLevelFromClass(event.currentTarget) || getDataAttr('menuItemLevel', event.currentTarget),
      target: event.currentTarget.id,
      navGroup: getDataAttr('menuItemGroup', event.currentTarget),
      tourStep: getDataAttr('onboardingCurrentStep', event.currentTarget),
      action: getDataAttr('clickAction', event.currentTarget),
      numOfShortcuts: getDataAttr('shortcutCount', event.currentTarget)
    };
    track('notificationInteraction', payload);
  };
  return {
    trackNotificationsClick,
    track
  };
};
export default useUsageTracker;